import { render, staticRenderFns } from "./UncannyAutomator.vue?vue&type=template&id=47cf6ae7&scoped=true"
import script from "./UncannyAutomator.vue?vue&type=script&lang=js"
export * from "./UncannyAutomator.vue?vue&type=script&lang=js"
import style0 from "./UncannyAutomator.vue?vue&type=style&index=0&id=47cf6ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cf6ae7",
  null
  
)

export default component.exports